/**
 * 普惠相关页面
 */
const puhuiRouter = [
  {
    path: '/puhui',
    component: () => import('@/views/puhui/home'),
    name: 'PuhuiHome',
    meta: { title: '普惠平台', auth: false, keepAlive: true }
  },
  // 会员管理
  {
    path: '/puhui/services/member',
    component: () => import('@/views/puhui/services/member/index'),
    name: 'PuhuiMemberService',
    meta: { title: '会员管理', auth: false }
  },
  {
    path: '/puhui/services/member/do',
    component: () => import('@/views/puhui/services/member/do'),
    name: 'PuhuiMemberDo',
    meta: { title: '办理会员证指南', auth: false }
  },
  {
    path: '/puhui/services/member/join',
    component: () => import('@/views/puhui/services/member/join'),
    name: 'PuhuiMemberJoin',
    meta: { title: '入会指南', auth: false }
  },
  {
    path: '/puhui/services/member/manage',
    component: () => import('@/views/puhui/services/member/manage'),
    name: 'PuhuiMemberManage',
    meta: { title: '会员管理知识点', auth: false }
  },
  {
    path: '/puhui/about',
    component: () => import('@/views/puhui/services/about'),
    name: 'PuhuiAbout',
    meta: { title: '关于普惠平台', auth: false }
  },
  // 工会服务
  {
    path: '/puhui/services/staff',
    component: () => import('@/views/puhui/services/staff/index'),
    name: 'PuhuiStaffService',
    meta: { title: '工会服务', auth: false }
  },
  {
    path: '/puhui/services/staff/difficulty',
    component: () => import('@/views/puhui/services/staff/difficulty'),
    name: 'PuhuiStaffDifficulty',
    meta: { title: '解困申请流程', auth: false }
  },
  {
    path: '/puhui/services/staff/gymnasium',
    component: () => import('@/views/puhui/services/staff/gymnasium'),
    name: 'PuhuiStaffGymnasium',
    meta: { title: '球馆活动信息', auth: false }
  },
  {
    path: '/puhui/services/staff/help',
    component: () => import('@/views/puhui/services/staff/help'),
    name: 'PuhuiStaffHelp',
    meta: { title: '互助保障申请指南', auth: false }
  },
  {
    path: '/puhui/services/staff/home',
    component: () => import('@/views/puhui/services/staff/home'),
    name: 'PuhuiStaffHome',
    meta: { title: '职工之家活动信息', auth: false }
  },
  {
    path: '/puhui/services/staff/love',
    component: () => import('@/views/puhui/services/staff/love'),
    name: 'PuhuiStaffLove',
    meta: { title: '婚恋服务信息', auth: false }
  },
  {
    path: '/puhui/services/staff/sweepblack',
    component: () => import('@/views/puhui/services/staff/sweepblack'),
    name: 'PuhuiStaffSweepblack',
    meta: { title: '扫黑除恶宣传窗口', auth: false }
  },
  {
    path: '/puhui/services/staff/train',
    component: () => import('@/views/puhui/services/staff/train'),
    name: 'PuhuiStaffTrain',
    meta: { title: '培创中心简介', auth: false }
  },
  // 公共服务
  {
    path: '/puhui/services/shehuifuwu',
    component: () => import('@/views/puhui/services/shehuifuwu/index'),
    name: 'PuhuiServiceSheHuiFuWu',
    meta: { title: '公共服务', auth: false }
  },
  // 市民卡
  {
    path: '/puhui/services/shehuifuwu/citizencard',
    component: () => import('@/views/puhui/services/shehuifuwu/citizencard'),
    name: 'PuhuiServiceCitizencard',
    meta: { title: '市民卡', auth: false }
  },
  // 金融服务
  {
    path: '/puhui/services/financial',
    component: () => import('@/views/puhui/services/financial/index'),
    name: 'PuhuiServiceFinancial',
    meta: { title: '金融服务', auth: false }
  },
  {
    path: '/puhui/services/financial/animal',
    component: () => import('@/views/puhui/services/financial/animal'),
    name: 'PuhuiFinancialAnimal',
    meta: { title: '工银生肖信用卡', auth: false }
  },
  {
    path: '/puhui/services/financial/courier',
    component: () => import('@/views/puhui/services/financial/courier'),
    name: 'PuhuiFinancialCourier',
    meta: { title: '工银信使', auth: false }
  },
  {
    path: '/puhui/services/financial/gugong',
    component: () => import('@/views/puhui/services/financial/gugong'),
    name: 'PuhuiFinancialGugong',
    meta: { title: '工行精美故宫卡办理', auth: false }
  },
  {
    path: '/puhui/services/financial/money',
    component: () => import('@/views/puhui/services/financial/money'),
    name: 'PuhuiFinancialMoney',
    meta: { title: '理财产品', auth: false }
  },
  {
    path: '/puhui/services/financial/products',
    component: () => import('@/views/puhui/services/financial/products'),
    name: 'PuhuiFinancialProducts',
    meta: { title: '工行理财产品', auth: false }
  },
  {
    path: '/puhui/services/financial/puhui',
    component: () => import('@/views/puhui/services/financial/puhui'),
    name: 'PuhuiFinancialPuhui',
    meta: { title: '办理信用卡', auth: false }
  },
  {
    path: '/puhui/services/financial/safeins',
    component: () => import('@/views/puhui/services/financial/safeins'),
    name: 'PuhuiFinancialSafeins',
    meta: { title: '工银信用卡账户安全险', auth: false }
  },
  {
    path: '/puhui/services/financial/safelock',
    component: () => import('@/views/puhui/services/financial/safelock'),
    name: 'PuhuiFinancialSafelock',
    meta: { title: '工银信用卡账户安全锁', auth: false }
  },
  {
    path: '/puhui/services/financial/universe',
    component: () => import('@/views/puhui/services/financial/universe'),
    name: 'PuhuiFinancialUniverse',
    meta: { title: '宇宙星座信用卡', auth: false }
  },
  {
    path: '/puhui/services/financial/world',
    component: () => import('@/views/puhui/services/financial/world'),
    name: 'PuhuiFinancialWorld',
    meta: { title: 'World奋斗信用卡', auth: false }
  }
]

export default puhuiRouter
